import { buildAnswer, IsBoolChoice, IsInline, isQuestionVisible } from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect } from 'react';
import { removeAnswers } from 'store/actions';
import { type QuestionProps, QuestionType } from 'types';

export function useQuestion(props: QuestionProps) {
	const { choices, dependsOnQuestionId, id, isSubquestion, questionType, testId } = props;
	const { dispatch, state, t } = useContext(AppContext);
	const depended = Number.isInteger(dependsOnQuestionId);
	const isBool = IsBoolChoice(choices);
	const inline = IsInline(choices);
	const framed = inline && !isBool;
	const isDropdown = !!(isSubquestion && !isBool && QuestionType.RadioMatrix === questionType);
	const iconTitle = t(`question_${id}_icon_title`, 'riskq');
	const isVisible = isQuestionVisible(props, state.riskq);

	useEffect(() => {
		if (!isVisible) {
			dispatch([removeAnswers, { riskq: [buildAnswer(testId, id, 0)] }]);
		}
	}, [id, isVisible, testId]); // eslint-disable-line react-hooks/exhaustive-deps

	return {
		...props,
		depended,
		framed,
		iconTitle,
		isBool,
		isDropdown,
		isVisible
	};
}
